import React, { PureComponent } from 'react';

import { canIUse, AppFeatures } from '../../helpers/PermissionUtility';
import { FormTag } from '../tags-types';

export type FormTagItemProps = {
  tag: FormTag;
  onRemove: (id: string) => void;
};

export default class FormTagItem extends PureComponent<FormTagItemProps, FormTag> {
  render() {
    const { tag, onRemove } = this.props;

    return (
      <div className="form-tag-item">
        {tag.tagName}
        <button
          className="plain-button delete-button"
          onClick={() => {
            onRemove(tag.tagId);
          }}
        >
          {canIUse(AppFeatures.TagAdd) ? <i className="ui icon delete" /> : null}
        </button>
      </div>
    );
  }
}
